import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {importProvidersFrom, NgModule} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule, NgbDropdownModule, NgbTooltipModule, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { OktaConfig } from '../environments/environment';
import { OKTA_CONFIG, OktaAuthModule } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import {
  AlertifyService,
  ConfirmModalModule,
  ErrorContainerModule,
  ErrorHandlerModule,
  ErrorShowingModule,
  InputTextModule, PrefixService,
  TableModule,
  ValidatedInputFieldModule,
  FileUploadModule, SchoolSelectorModule,
} from 'ccc-commons/core';
import { UiSwitchModule } from 'ngx-ui-switch';
import { Utils } from '@ccc-shared/utils/utils';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { AccountsService } from './core/services/accounts.service';
import { GeneralConfigurationService } from './core/services/general-configuration.service';
import { LicensesService } from './core/services/licenses.service';
import { LoginAsService } from './core/services/login-as.service';
import { OrganizationService } from './core/services/organization.service';
import { PermissionsService } from './core/services/permissions.service';
import { RoleService } from './core/services/role.service';
import { XrefService } from './core/services/xref.service';
import { RouteProxyComponent } from './shared/components/route-proxy/route-proxy.component';
import { UserModalModule } from './shared/components/user-modal/user-modal.module';
import { SettingsModule } from './settings/settings.module';
import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';
import { AccountsModule } from './shared/modules/accounts/accounts.module';
import { ConfigResolver } from '@ccc-core/resolvers/config.resolver';
import { NgProgressComponent } from 'ngx-progressbar';
import { NgProgressModule } from 'ngx-progressbar';
import { NgProgressRouterModule } from 'ngx-progressbar/router';
import { NgProgressHttpModule, NgProgressInterceptor } from 'ngx-progressbar/http';

@NgModule({
  declarations: [
    AppComponent,
    NotFoundComponent,
    RouteProxyComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CoreModule,
    SharedModule,
    SchoolSelectorModule.withConfig({
      districtIcon: 'assets/images/school.svg'
    }),
    NgProgressModule.withConfig({
      spinnerPosition: 'left',
      color: '#d77037',
      thick: true,
      spinner: false
    }),
    NgProgressRouterModule,
    NgProgressHttpModule,
    TableModule,
    NgbTooltipModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    NgSelectModule,
    BrowserAnimationsModule,
    NgbDatepickerModule,
    ConfirmModalModule,
    UiSwitchModule,
    NgbDropdownModule,
    ValidatedInputFieldModule,
    ErrorShowingModule,
    UserModalModule,
    ErrorContainerModule,
    InputTextModule,
    FileUploadModule,
    ErrorHandlerModule.forRoot(environment),
    SettingsModule,
    AccountsModule,
    NgProgressComponent,
    OktaAuthModule.forRoot({ oktaAuth: new OktaAuth(OktaConfig) }),
  ],
  providers: [
    OrganizationService,
    LicensesService,
    AlertifyService,
    importProvidersFrom(OktaAuthModule.forRoot({
        oktaAuth: new OktaAuth(OktaConfig)
    })),
    RoleService,
    PermissionsService,
    LoginAsService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    GeneralConfigurationService,
    XrefService,
    AccountsService,
    Utils,
    PrefixService,
    ConfigResolver,
    provideHttpClient(withInterceptorsFromDi())
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
